import { CheckedIcon } from '@wwe-portal/ui/components/icons/checked-icon';
import { FC } from 'react';

export const RosterWinrate: FC<{ winPercentage?: number }> = ({
  winPercentage,
}) => {
  if (!winPercentage) return null;
  return (
    <div className="drop-shadow-text text-xs font-semibold italic text-[#00FFEA]">
      Win Rate: <span className="text-white">{winPercentage}%</span>
      <CheckedIcon className="text-green600 ml-1 inline-block h-2 w-2" />
    </div>
  );
};
